// ==================== NewsSection.jsx ====================
import React, { useEffect, useState } from "react";
import {
  Gift,
  PartyPopper,
  Users,
  CalendarDays,
  UserPlus,
} from "lucide-react";
import "../Styling/NewsSection.css";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";

const NewsSection = () => {
  const { user } = useAuth();

  const [todayEvents, setTodayEvents] = useState({
    Birthday: [],
    "Work Anniversary": [],
    "New Joinee": [],
  });

  const [upcomingEvents, setUpcomingEvents] = useState({
    Birthday: [],
    "Work Anniversary": [],
    "New Joinee": [],
  });

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const isSameDay = (d1, d2) =>
    d1.getDate() === d2.getDate() &&
    d1.getMonth() === d2.getMonth();

  const getIcon = (type) => {
    switch (type) {
      case "Birthday":
        return <Gift size={14} />;
      case "Work Anniversary":
        return <PartyPopper size={14} />;
      case "New Joinee":
        return <UserPlus size={14} />;
      default:
        return <Users size={14} />;
    }
  };

  useEffect(() => {
    const sortByDate = (grouped) => {
  Object.keys(grouped).forEach((key) => {
    grouped[key].sort(
      (a, b) => new Date(a.sortDate) - new Date(b.sortDate)
    );
  });
};

    if (!user?.organisationId) return;

    fetch(`${Base_URL}/SalaryProcess/ResourceMasters/${user.organisationId}`)
      .then((res) => res.text())
      .then((text) => (text ? JSON.parse(text) : []))
      .then((data) => {
        const todayGrouped = {
          Birthday: [],
          "Work Anniversary": [],
          "New Joinee": [],
        };

        const upcomingGrouped = {
          Birthday: [],
          "Work Anniversary": [],
          "New Joinee": [],
        };

        data.forEach((emp) => {
          const dob = emp.dob ? new Date(emp.dob) : null;
          const doj = emp.doj ? new Date(emp.doj) : null;

          const base = {
            name: emp.name,
            role: emp.role,
            department: emp.department,
          };

          // TODAY
          if (dob && isSameDay(dob, today)) {
            todayGrouped.Birthday.push({ ...base, date: "Today", sortDate: today, });
          }

          if (doj && isSameDay(doj, today)) {
            todayGrouped["Work Anniversary"].push({
              ...base,
              date: "Today",
              sortDate: today,
            });
            todayGrouped["New Joinee"].push({ ...base, date: "Today" , sortDate: today,});
          }

          // UPCOMING (30 days)
          const next30 = new Date(today);
          next30.setDate(today.getDate() + 30);

          if (dob) {
            const d = new Date(dob);
            d.setFullYear(today.getFullYear());
            if (d > today && d <= next30) {
              upcomingGrouped.Birthday.push({
                ...base,
                date: d.toDateString(),
                sortDate: d,
              });
            }
          }

          if (doj) {
            const d = new Date(doj);
            d.setFullYear(today.getFullYear());
            if (d > today && d <= next30) {
              upcomingGrouped["Work Anniversary"].push({
                ...base,
                date: d.toDateString(),
                sortDate: d,
              });
            }
          }
        });
        sortByDate(todayGrouped);
sortByDate(upcomingGrouped);
        setTodayEvents(todayGrouped);
        setUpcomingEvents(upcomingGrouped);
      })
      .catch(() => {
        setTodayEvents({
          Birthday: [],
          "Work Anniversary": [],
          "New Joinee": [],
        });
        setUpcomingEvents({
          Birthday: [],
          "Work Anniversary": [],
          "New Joinee": [],
        });
      });
  }, [user?.organisationId]);

  const renderSection = (title, icon, data, type) => (
    <div className="news-section">
      <h5 className={`news-section-title ${type}`}>
        {icon} {title}
      </h5>

      <div className="news-horizontal-row">
        {Object.entries(data).map(([key, items]) => (
          <div key={key} className="news-box">
            <div className="news-box-title">
              {getIcon(key)} {key}
            </div>

            {items.length === 0 ? (
              <p className="news-empty">No events</p>
            ) : (
              items.map((item, idx) => (
                <div key={idx} className="news-item">
                  <p className="news-name">{item.name}</p>
                  <p className="news-sub">
                    {item.role} • {item.department}
                  </p>
                  {item.date !== "Today" && (
                    <span className="news-date">{item.date}</span>
                  )}
                </div>
              ))
            )}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="news-card compact">
      <div className="news-header">
        <div className="news-icon">
          <Users size={18} />
        </div>
        <div>
          <h4>News & Events</h4>
          <p>Birthdays, anniversaries & joinees</p>
        </div>
      </div>

      {renderSection("Today", <Users size={14} />, todayEvents, "today")}
      {renderSection(
        "Upcoming (30 Days)",
        <CalendarDays size={14} />,
        upcomingEvents,
        "upcoming"
      )}
    </div>
  );
};

export default NewsSection;
